/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Snap_To_Shot_Changes_FailedInputs */

const en_snap_to_shot_changes_failed = /** @type {(inputs: Snap_To_Shot_Changes_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Snap To shot changes failed with message: ${i?.error}`)
};

const fr_snap_to_shot_changes_failed = /** @type {(inputs: Snap_To_Shot_Changes_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de l’alignement sur les changements de plan : ${i?.error}`)
};

const de_snap_to_shot_changes_failed = /** @type {(inputs: Snap_To_Shot_Changes_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Snap-To-Aufnahmeänderungen fehlgeschlagen mit der Meldung: ${i?.error}`)
};

const it_snap_to_shot_changes_failed = /** @type {(inputs: Snap_To_Shot_Changes_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Modifiche Snap To shot non riuscite con messaggio: ${i?.error}`)
};

const ru_snap_to_shot_changes_failed = /** @type {(inputs: Snap_To_Shot_Changes_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Изменения в снимке Snap To не удались, сообщение об ошибке: ${i?.error}`)
};

const es_snap_to_shot_changes_failed = /** @type {(inputs: Snap_To_Shot_Changes_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Los cambios en Ajustar a la toma fallaron con el mensaje: ${i?.error}`)
};

const zh_cn2_snap_to_shot_changes_failed = /** @type {(inputs: Snap_To_Shot_Changes_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`快照更改失败，错误信息：${i?.error}`)
};

const ja_snap_to_shot_changes_failed = /** @type {(inputs: Snap_To_Shot_Changes_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`スナップ ショットの変更が失敗しました。メッセージ: ${i?.error}`)
};

const hi_snap_to_shot_changes_failed = /** @type {(inputs: Snap_To_Shot_Changes_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`स्नैप टू शॉट में बदलाव विफल हो गए, संदेश आया: ${i?.error}`)
};

const pt_pt2_snap_to_shot_changes_failed = /** @type {(inputs: Snap_To_Shot_Changes_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A alteração de disparo automático falhou com a mensagem: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Snap To shot changes failed with message: {error}" |
*
* @param {Snap_To_Shot_Changes_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_shot_changes_failed = /** @type {((inputs: Snap_To_Shot_Changes_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Shot_Changes_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snap_to_shot_changes_failed(inputs)
	if (locale === "de") return de_snap_to_shot_changes_failed(inputs)
	if (locale === "it") return it_snap_to_shot_changes_failed(inputs)
	if (locale === "ru") return ru_snap_to_shot_changes_failed(inputs)
	if (locale === "es") return es_snap_to_shot_changes_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_snap_to_shot_changes_failed(inputs)
	if (locale === "ja") return ja_snap_to_shot_changes_failed(inputs)
	if (locale === "hi") return hi_snap_to_shot_changes_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_snap_to_shot_changes_failed(inputs)
	return en_snap_to_shot_changes_failed(inputs)
});